<template>
    <div class="diploma-form">
        <b-modal
            id="diploma-modal"
            ref="diploma-modal"
            :title="title"
            :title-class="['h3','text-secondary']"
            centered
            size="lg"
            header-close-variant="light"
            header-bg-variant="dark"
            cancel-title = "Cancelar"
            @hidden="hiddenModal"
            @ok="handleOk"
            no-close-on-backdrop
            >
              <b-form ref="DiplomaForm" @submit.stop.prevent>
                <fieldset :disabled="formDisabled">
                  <b-form-row>
                    <b-col sm="12" md="6">
                      <b-form-group
                        :label="'Seleccione el Tipo de ' + label"
                        label-for="diploma_template"
                        label-class="text-left"
                        :invalid-feedback="diploma_template_idError"
                      >
                        <b-form-select 
                          @change="templateChanged" 
                          v-model="thing.diploma_template_id" 
                          :options="my_data.diploma_templates"
                          :state="diploma_template_idError?false:true"></b-form-select>
                      </b-form-group>
                  </b-col>
                  <b-col sm="12" md="6" v-if="!diploma_generated">
                    <b-form-group
                      :state="emailError?false:true"
                      :label="'Correo a donde enviaremos ' + label "
                      label-for="email"
                      label-class="text-left"
                      :invalid-feedback="emailError"
                    >
                      <b-form-input
                        trim
                        aria-label="Email"
                        id="email"
                        placeholder="Email"
                        v-model="thing.email"
                        :state="emailError?false:true"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col sm="12" md="6" v-if="!diploma_generated">
                    <b-form-group
                      :state="nameError?false:true"
                      label="Nombre(s)"
                      label-for="name"
                      label-class="text-left"
                      :invalid-feedback="nameError"
                    >
                      <b-form-input
                        trim
                        aria-label="Name"
                        id="name"
                        @change="nameChanged"
                        v-model="thing.name"
                        placeholder="Nombre(s)"
                        :state="nameError?false:true"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col sm="12" md="6" v-if="!diploma_generated">
                    <b-form-group
                      :state="last_nameError?false:true"
                      label="Apellido Paterno"
                      label-for="last_name"
                      label-class="text-left"
                      :invalid-feedback="last_nameError"
                    >
                      <b-form-input
                        trim
                        type="text"
                        aria-label="Apellido Paterno"
                        @change="lastNameChanged"
                        id="last_name"
                        v-model="thing.last_name"
                        placeholder="Apellido Paterno"
                        :state="last_nameError?false:true"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col sm="12" md="6" v-if="!diploma_generated">
                    <b-form-group
                      :state="mother_last_nameError?false:true"
                      label-for="mother_last_name"
                      label="Apellido Materno"
                      label-class="text-left"
                      :invalid-feedback="mother_last_nameError"
                    >
                      <b-form-input
                        trim
                        type="text"
                        @change="motherLastNameChanged"
                        aria-label="Apellido Materno"
                        id="mother_last_name"
                        v-model="thing.mother_last_name"
                        placeholder="Apellido Materno"
                        :state="mother_last_nameError?false:true"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col sm="12" md="6" v-if="!diploma_generated && my_data.license_is_valid">
                    <b-form-group
                      :state="licenseError?false:true"
                      label-for="license"
                      label="Cédula Profesional"
                      label-class="text-left"
                      :invalid-feedback="licenseError"
                    >
                      <b-form-input
                        trim
                        type="text"
                        aria-label="Cédula Profesional"
                        id="license"
                        v-model="thing.license"
                        placeholder="XXXXXXXXX"
                        :state="licenseError?false:true"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" v-if="!diploma_generated">
                    <b-form-group
                      :state="nameError?false:true"
                      :label="labelForm"
                      label-for="diploma_name"
                      label-class="text-left"
                    >
                      <b-form-input
                        aria-label="Name"
                        id="diploma_name"
                        v-model="diploma_name"
                        placeholder=""
                        disabled
                      ></b-form-input>
                    </b-form-group>
                    <span v-if="assistant_key_idError" class="text-danger">{{this.assistant_key_idError}}</span>
                  </b-col>
                  </b-form-row>
                </fieldset>
              </b-form>
              <h2 v-if="!diploma_generated" class="text-center text-success">Verifique que los datos para la constancia sean los correctos.</h2>
              <template v-slot:modal-footer>
                <b-row>
                  <b-col md="2">
                    <b-button-group class="float-right" size="md">
                      <b-button v-if="!formDisabled" @click="onSubmit" variant="danger">
                        {{btnTitle}}
                      </b-button>
                    </b-button-group>
                  </b-col>
                </b-row>
              </template>
        </b-modal>
    </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
    name: 'DiplomaForm',
    props: {
      assistant: { type: Object, default: () => ({}) },
      label: { type: String, default: 'la Constancia '},
      valid_exam : { type: Boolean, default: false },
      floatingRules: { type: Array, default: () => [] },
    },
    data() {
        return {
          thing: {
            id: null,
            assistant_key_id: null,
            name: null,
            event_key_id: null,
            email: null,
            diploma_template_id: null,
            last_name: null,
            mother_last_name: null,
            license: null,
          },
          diploma: {
            file_path_url: null,
          },
          my_data: {
            name: null, 
            last_name: null, 
            mother_last_name: null, 
            email: null, 
            exam_approved: false, 
            remaining_attempts: null,
            diploma_templates: [],
            diplomas: []
          },
          formDisabled: false,
          errors: [],
          diploma_generated: true,
          diploma_name: null
        }
    },
    methods: {
      lastNameChanged(value) {
        this.diploma_name = ''
        if(this.thing.name) this.diploma_name += this.thing.name
        this.diploma_name += ' ' + value.trim()
        if(this.thing.mother_last_name) this.diploma_name += ' ' + this.thing.mother_last_name
      },
      nameChanged(value) {
        this.diploma_name = ''
        this.diploma_name += value.trim()
        if(this.thing.last_name) this.diploma_name += ' ' + this.thing.last_name
        if(this.thing.mother_last_name) this.diploma_name += ' ' + this.thing.mother_last_name
      },
      motherLastNameChanged(value) {
        this.diploma_name = ''
        if(this.thing.name) this.diploma_name += this.thing.name
        if(this.thing.last_name) this.diploma_name += ' ' + this.thing.last_name
        this.diploma_name += ' ' + value.trim()
      },
      templateChanged(value) {
        let temp= this.my_data.diplomas.find((item) => item.diploma_template_id === value )
        if(temp) {
          this.diploma_generated = true
          this.loadDiploma()
        } else this.diploma_generated = false
      },
      loadMyData() {
        let floatingRules = null
        if (this.floatingRules && this.floatingRules.length>0 && this.floatingRules[0].diploma_template_id ) floatingRules = this.floatingRules
        let url = '/assistants/my_data'
        let method = 'post'
        this.$store.dispatch(method, {'url':url, data: {key_id: this.assistant.key_id, floatingRules:floatingRules}, headers:{}})
          .then((resp) => {
            this.my_data = resp.data
            this.thing.email = this.my_data.email
            this.thing.name = this.my_data.name
            this.thing.last_name = this.my_data.last_name
            this.thing.mother_last_name = this.my_data.mother_last_name
            this.thing.license = this.my_data.license
            this.nameChanged(this.my_data.name)
            this.$nextTick(() => { 
              if(this.my_data.answered_survey || !this.valid_exam) {
                if (this.floatingRules.length>0 && this.floatingRules[0].forced_exam === 1) {
                  if(this.my_data.exam_approved <= 0 ) {
                    this.hiddenModal({
                      'text': 'Debe acreditar el examen para obtener su constancia de Alergólogos con Aval.',
                      'title': 'Aviso'
                    })
                  }
                }
                this.loadDiploma()
              } else this.hiddenModal({
                'text': 'Antes de descargar su Constancia, conteste una simple encuesta.',
                'title': 'Aviso'
              }) 
            })
          })
          .catch(err => {
            console.log(err)
            this.hiddenModal()
          })
      },
      loadDiploma() {
        let loader = this.$loading.show()
        this.$store.dispatch(
          'download', 
          {
            'url':'/diplomas/my_diploma', 
            data: {assistant_key_id: this.assistant.key_id, diploma_template_id: this.thing.diploma_template_id}, 
            'method':'POST', 
            headers:{}
          })
          .then((resp) => {
            loader.hide()
            const blob = new Blob([resp.data], { type: 'application/pdf' })
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = 'constancia'
            link.click()
            URL.revokeObjectURL(link.href)
            this.hiddenModal()
          })
          .catch(err => {
            loader.hide()
            if(err.error) alert(err.error)
            this.showModal()
          })
      },
      showModal() {
        this.$bvModal.show('diploma-modal')
      },
      hiddenModal(msg) {
        if(msg) this.$emit('closed', msg)
        else this.$emit('closed')
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.save_thing()
      },
      onSubmit() {
        let loader = this.$loading.show()
        this.thing.event_key_id= this.eventKeyId
        this.thing.assistant_key_id = this.assistant.key_id
        this.errors = []
        this.formDisabled = true
        let url = '/diplomas/create_diploma'
        let method = 'post'
        this.$store.dispatch(method, {'url':url, data: this.thing, headers:{}})
          .then((resp) => {
            loader.hide()
            this.thing = resp.data
            this.$nextTick(() => {
              this.loadDiploma()
            })
              
          })
          .catch(err => {
            loader.hide()
            this.formDisabled = false
            this.errors = err.errors
            if(err.error) alert(err.error)
          })
      },
    },
    beforeMount() {
      
    },
    mounted() {
      this.loadMyData()
    },
    computed: {
      labelForm() {
        return "Nombre completo en " + this.label
      },
      eventKeyId() {
        return this.$store.getters.eventKeyId
      },
      title: function() {
        return 'Descarga ' + this.label
      },
      btnTitle: function() {
        return 'Descargar'
      },
      emailError: function () {
        if(this.errors && this.errors.email) return this.errors.email[0]
        return null
      },
      nameError: function () {
        if(this.errors && this.errors.name) return this.errors.name[0]
        return null
      },
      last_nameError: function () {
        if(this.errors && this.errors.last_name) return this.errors.last_name[0]
        return null
      },
      mother_last_nameError: function () {
        if(this.errors && this.errors.mother_last_name) return this.errors.mother_last_name[0]
        return null
      },
      licenseError: function () {
        if(!this.thing.license || (this.thing.license.trim().length< 1) ) return 'Digíte su cédula profesional'
        if(this.errors && this.errors.license) return this.errors.license[0]
        return null
      },
      nameError: function () {
        if(this.errors && this.errors.name) return this.errors.name[0]
        return null
      },
      assistant_key_idError: function () {
        if(this.errors && this.errors.assistant_key_id) return this.errors.assistant_key_id[0]
        return null
      },
      diploma_template_idError: function () {
        if(this.errors && this.errors.diploma_template_id) return this.errors.diploma_template_id[0]
        return null
      },
    },
})
</script>

<style lang="scss" scoped>
@import '../../styles/app';
</style>
